import { Outlet } from "react-router-dom";
import Constants from "./helper/constants";

export default function Recordings() {
  return (
    <div className="pageContainer" style={{minHeight: window.innerHeight - Constants.footerHeight}}>
      <Outlet />
    </div>
  );
}